@if (isMobile()) {
<button pButton type="button" severity="secondary" text class="p-2" (click)="showDialog()">
  <svg data-p-icon="search" class="size-5"></svg>
</button>
} @else {
<div class="relative w-64" (click)="showDialog()">
  <p-iconfield>
    <p-inputicon>
      <svg data-p-icon="Search"></svg>
    </p-inputicon>
    <input pInputText type="text" placeholder="Buscar módulo..." class="cursor-pointer w-full pr-10" readonly
      pSize="small" />
  </p-iconfield>
  <span
    class="absolute right-1.5 top-1/2 -translate-y-1/2 text-[10px] border border-surface-300 dark:border-surface-600 rounded px-1.5 py-0.5 font-bold shadow-sm bg-surface-100 dark:bg-surface-800 pointer-events-none text-surface-500">ctrl
    + K</span>
</div>
}

<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [showHeader]="false" [dismissableMask]="true"
  styleClass="w-full max-w-xl mx-4 shadow-2xl rounded-xl overflow-hidden backdrop-blur-xl bg-surface-0/90 dark:bg-surface-900/90 border border-surface-200/50 dark:border-surface-700/50"
  maskStyleClass="backdrop-blur-sm bg-surface-900/40">

  <div class="flex flex-col">
    <div class="flex items-center px-4 border-b border-surface-200/50 dark:border-surface-700/50">
      <svg data-p-icon="search" class="size-5 text-primary-500 dark:text-primary-400"></svg>
      <input type="text"
        class="w-full bg-transparent border-none p-4 text-surface-900 dark:text-surface-0 outline-none focus:ring-0 placeholder:text-surface-400"
        placeholder="Buscar módulos..." [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()"
        (keydown.enter)="onEnter()" (keydown.arrowDown)="onArrowDown($event)" (keydown.arrowUp)="onArrowUp($event)"
        autofocus>
      <span
        class="text-xs text-surface-400 border border-surface-200 dark:border-surface-700 rounded px-1.5 py-0.5 cursor-pointer hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors"
        (click)="hideDialog()">ESC</span>
    </div>

    <div
      class="max-h-[60vh] overflow-y-auto p-2 scrollbar-thin scrollbar-thumb-surface-200 dark:scrollbar-thumb-surface-700">
      @if (displayItems().length === 0) {
      <div class="p-8 text-center text-surface-500 dark:text-surface-400 text-sm flex flex-col items-center gap-2">
        <svg data-p-icon="search" class="size-8 text-surface-300 dark:text-surface-600 mb-2"></svg>
        No se encontraron módulos
      </div>
      } @else {
      <div class="flex flex-col gap-1">
        @if (!searchQuery() && recentItems().length > 0) {
        <div class="px-3 py-2 text-xs font-semibold text-surface-500 dark:text-surface-400 uppercase tracking-wider">
          Recientes
        </div>
        }

        @for (item of displayItems(); track item.routerLink; let i = $index) {
        <button [id]="'cmd-item-' + i"
          class="w-full flex items-center gap-3 px-3 py-3 rounded-lg text-left transition-colors border border-transparent"
          [class]="i === selectedIndex() ? 'bg-primary-50 dark:bg-primary-900/30 border-primary-100 dark:border-primary-800/50' : 'hover:bg-surface-100 dark:hover:bg-surface-800'"
          (click)="navigate(item)">
          <div class="flex items-center justify-center size-8 rounded-md shrink-0 transition-colors"
            [class]="i === selectedIndex() ? 'bg-primary-100 dark:bg-primary-800 text-primary-600 dark:text-primary-300' : 'bg-surface-100 dark:bg-surface-800 text-surface-500 dark:text-surface-400'">
            <svg [pIcon]="item.icon || 'file'" class="size-4"></svg>
          </div>
          <div class="flex flex-col flex-1">
            <span class="text-sm font-medium transition-colors"
              [class]="i === selectedIndex() ? 'text-primary-700 dark:text-primary-300' : 'text-surface-900 dark:text-surface-0'">{{
              item.label }}</span>
            @if (item.groupLabel) {
            <span class="text-xs transition-colors"
              [class]="i === selectedIndex() ? 'text-primary-600/70 dark:text-primary-400/70' : 'text-surface-500 dark:text-surface-400'">{{
              item.groupLabel }}</span>
            }
          </div>
          @if (i === selectedIndex()) {
          <span
            class="text-xs text-primary-600 dark:text-primary-400 font-medium px-2 py-1 bg-primary-100 dark:bg-primary-800 rounded shrink-0">Enter
            ↵</span>
          }
        </button>
        }
      </div>
      }
    </div>
  </div>
</p-dialog>